const useShouldShowPoll = (
  isBannerModeActive,
  contentIsVideo,
  userProperties,
) => {
  const { isStudent, isTeacher } = userProperties;
  const isPollsUser = isTeacher || isStudent;

  const shouldShowPoll = isPollsUser && !isBannerModeActive && !contentIsVideo;

  return shouldShowPoll;
};

export default useShouldShowPoll;
